<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="上传费用凭证"
    :visible.sync="dialogVisible"
    width="800px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" class="form" label-position="top">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="receiveAmount" label="费用">
              <el-input
                v-model="receiveAmount"
                placeholder="请输入费用"
                suffix-icon="USD"
              >
                <span slot="suffix"> USD </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="source" label="类型">
              <el-select
                v-model="source"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, $index) in options"
                  :key="$index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="receiveAmount" label="文件">
              <el-upload
                class="upload-demo"
                action="#"
                :limit="1"
                :show-file-list="false"
                :http-request="httpRequest"
              >
                <el-button class="btn" size="small">
                  <svg-icon iconClass="upload" className="icon" />
                  选择文件上传
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button class="btn" style="    margin-top: 30px;" size="small" @click="ok">确定上传</el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- <base-upload
        ref="baseUpload"
        style="margin-top: 20px"
        :action="action"
        class="upload"
        @success="success"
        @beforeUpload="beforeUpload"
      ></base-upload> -->
      <BaseTable
        :height="400"
        style="margin-top: 10px;"
        :tableData="tableData"
        :isPager="false"
        :isEmptyBorder="true"
      >
        <template v-if="row.scope.fileName" slot="opt" slot-scope="row">
          <el-button
            type="text"
            size="mini"
            @click="review(row.scope)"
          >预览</el-button>
          <el-button
            type="text"
            style="margin-left: 24px;"
            size="mini"
            @click="download(row.scope)"
          >下载</el-button>
        </template>
      </BaseTable>
    </div>
    <!-- <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span> -->
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { mblHoldFiles, downLoadMBLFile } from '@/api/bill'
import { uploadHoldMBLFile } from '@/api/system'
// import config from '@/utils/config'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      options: [
        {
          value: 13,
          label: '查验费'
        },
        {
          value: 14,
          label: '查验服务费'
        },
        {
          value: 1001,
          label: '码头杂费'
        },
        {
          value: 1002,
          label: '提柜费'
        },
        {
          value: 1003,
          label: 'X光费'
        },
        {
          value: 1004,
          label: '销毁费'
        },
        {
          value: 1005,
          label: '3499费'
        },
        {
          value: 1006,
          label: '查验场费'
        },
        {
          value: 1007,
          label: '代付手续费'
        },
        {
          value: 1008,
          label: '查验场仓租'
        },
        {
          value: 1009,
          label: '码头仓租'
        },
        {
          value: 1010,
          label: '柜租'
        },
        {
          value: 99,
          label: '其他'
        }
      ],
      receiveAmount: '',
      source: 13,
      fileList: [],
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'typeName',
            label: '费用类型',
            width: ''
          },
          {
            filed: 'totalAmount',
            label: '金额',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      }
    }
  },
  computed: {
    // action() {
    //   return `/api/SystemFile/uploadHoldMBLFile?source=${this.source}&receiveAmount=${this.receiveAmount}&id=${this.rowData.mblId}`
    // }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.fileList = []
        this.source = 13
        this.receiveAmount = ''
        this.getList()
      }
    }
  },
  created() {
        this.fileList = []
        this.source = 13
        this.receiveAmount = ''
        this.getList()
  },
  methods: {
    async getList() {
      try {
        const res = await mblHoldFiles({
          mblId: this.rowData.mblId
        })
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      // this.$refs.baseUpload.init()
      this.$emit('cancel')
    },
   async ok() {
      // this.$refs.baseUpload.init()
      // this.$emit('cancel')
      try {
        this.loading = true
        const formdata = new FormData()
        if (this.fileList.length) {
          formdata.append('file', this.fileList[0])
        }
        const parmas = {
          source: this.source,
          receiveAmount: this.receiveAmount,
          id: this.rowData.mblId
        }
        const res = await uploadHoldMBLFile(formdata, parmas)
        this.loading = false
        if (res.data.success) {
          this.$message.success('上传成功')
          // this.getList()
          // this.$refs.baseUpload.init()
          this.$emit('cancel')
        } else {
          this.$message.error(res.data.errorMessage)
        }
        this.fileList = []
      } catch (error) {
        this.loading = false
        this.$message.error(`上传失败:${error.response?.data?.errorMessage}`)
        console.log(error)
      }
    },
    success(res) {
      if (res.success) {
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.errorMessage)
      }
      this.fileList = []
    },
    httpRequest({ file }) {
      this.fileList = [file]
    },
    beforeUpload() {
      if (!this.receiveAmount) {
        this.$message.error('先填写费用')
        return false
      }
    },
    review(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )?.toLowerCase()
      // const { fileGuid } = item
      if (suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png') {
        this.$viewerApi({
          images: item.filePath
        })
      } else if (suffix === 'pdf') {
        window.open(item.filePath)
      } else {
        this.$message('暂时只支持图片和PDF查看')
      }
    },
    async download(v) {
      try {
        const res = await downLoadMBLFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  .btn {
    width: 160px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgb(18, 88, 188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    .icon {
      font-size: 24px;
      vertical-align: middle;
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
/deep/ .el-dialog__body {
  padding: 0px 60px 40px;
}
/deep/ .el-dialog__header {
  border: 0;
}
</style>
